import Entity from '../Entity';

import Pref from '../Pref';

import ImageUrlHelper, {Options} from '../../helpers/ImageUrlHelper';
import Gender from '../../value_objects/Gender';

export default class UserProfile implements Entity {
  constructor(
    public id: number,
    public description: string,
    public hasImage: boolean,
    public originalImageUrl: string,
    public gender: Gender | null,
    public birthday: Date | null,
    public pref: Pref | null,
  ) {}

  public getImageUrl(options: Options): string {
    return ImageUrlHelper.getImageUrl(this.originalImageUrl, options);
  }
}
